export function Nav() {
  return (
    <header className="nav">
      <div className="container nav-inner">
        <a href="#top" className="nav-brand" aria-label="Tiny Cloud home">
          <img src="/logo.png" alt="" />
          <span>Tiny Cloud</span>
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="#services">Services</a>
          <a href="#work">Work</a>
          <a href="#inquiry">Contact</a>
          <a className="btn btn-primary" href="#inquiry">
            Book a call <span className="arrow">→</span>
          </a>
        </nav>
      </div>
    </header>
  );
}
